import React from 'react'
import { connect } from 'react-redux'
import Select from 'react-select'
import SupplierActions from '../../Redux/SupplierRedux'
import LocationActions from '../../Redux/LocationRedux'

class UpdateSupplier extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      name: '',
      
      selectedProvince: {},
      selectedCity: {},
      selectedDistrict: {},
      
      address_sub_district: '',
      address: '',
      postal_code: '',

      error: {
        name: '',
        province: '',
        selectedCity: '',
        selectedDistrict: '',
        address_sub_district: '',
        address: '',
        postal_code: ''
      }
    }
  }

  componentDidMount = () => {
    let state = { ...this.state }
    let detail = this.props.detail

    state.name = detail.name

    if (detail.supplier_address) {
      state.address = detail.supplier_address.address
      state.postal_code = detail.supplier_address.postal_code
      state.address_sub_district = detail.supplier_address.address_sub_district

      state.selectedDistrict = {
        value: detail.supplier_address.district.id,
        label: detail.supplier_address.district.name
      }

      state.selectedCity = {
        value: detail.supplier_address.city.id,
        label: detail.supplier_address.city.name
      }

      state.selectedProvince = {
        value: detail.supplier_address.province.id,
        label: detail.supplier_address.province.name
      }

      this.props.getCities(state.selectedProvince.value)
      this.props.getDistricts(state.selectedCity.value)
    }
    
    this.setState(state)

    this.props.getProvince()
  }

  _inputChange = (event, field) => {
    let value = event.target.value
    this.setState({ [field]: value })
  }

  _locationProvinceChange = (selectedProvince) => {
    this.props.getCities(selectedProvince.value)
    this.setState({ selectedProvince, selectedCity: {}, selectedDistrict: {} })
  }

  _locationCityChange = (selectedCity) => {
    this.props.getDistricts(selectedCity.value)
    this.setState({ selectedCity, selectedDistrict: {} })
  }

  _locationDistrictChange = (selectedDistrict) => {
    this.setState({ selectedDistrict })
  }

  validateSupplier = () => {
    let valid = true
    let form = { ...this.state }
    let error = { ...this.state.error }

    if (form.name === '') {
      valid = false
      error.name = 'required'
    }

    if (form.address === '') {
      valid = false
      error.address = 'required'
    }

    if (form.postal_code === '') {
      valid = false
      error.postal_code = 'required'
    }

    if (!form.selectedProvince.value) {
      valid = false
      error.selectedProvince = 'required'
    }

    if (!form.selectedCity.value) {
      valid = false
      error.selectedCity = 'required'
    }

    if (!form.selectedDistrict.value) {
      valid = false
      error.selectedDistrict = 'required'
    }

    if (form.address_sub_district === '') {
      valid = false
      error.address_sub_district = 'required'
    }

    this.setState({ error })
    return valid
  }

  _submit = (event) => {
    event.preventDefault()
    let form = this.state

    if (this.validateSupplier() === true) {
      let data = {
        id: this.props.detail.id,
        form: {
          name: form.name,
          address: {
            address: form.address,
            address_province_id: form.selectedProvince.value,
            address_city_id: form.selectedCity.value,
            address_district_id: form.selectedDistrict.value,
            address_sub_district: form.address_sub_district,
            postal_code: form.postal_code
          }
        }
      }

      this.props.updateSupplier(data)
      setTimeout(() => {
        this.props.closeModal()
      }, 250)
    }
  }

  render () {
    let province = []
    let { location } = this.props

    location.province.map(dataProvince => {
      let objProvince = {
        value: dataProvince.id,
        label: dataProvince.name
      }

      return province.push(objProvince)
    })

    let city = []
    location.city.map(dataCity => {
      let objCity = {
        value: dataCity.id,
        label: dataCity.name
      }

      return city.push(objCity)
    })

    let district =  []
    location.district.map(dataDistrict => {
      let objDistrict = {
        value: dataDistrict.id,
        label: dataDistrict.name
      }

      return district.push(objDistrict)
    })

    return (
      <div className='section' style={{ width: '40vw' }}>
        <div className='title-block'>
          <h4 className='title mr-auto'>Update Supplier</h4>
        </div>
        <form onSubmit={(event) => this._submit(event)}>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Supplier Name</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Supplier Name'
                className='form-control'
                value={this.state.name}
                onChange={(event) => this._inputChange(event, 'name')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Address</label>
            </div>
            <div className='col-9'>
              <textarea
                rows='3'
                className='form-control'
                value={this.state.address}
                onChange={(event) => this._inputChange(event, 'address')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Province</label>
            </div>
            <div className='col-9'>
              <Select
                options={province}
                name='province-picker'
                required
                placeholder='Select Province'
                value={this.state.selectedProvince}
                onChange={(selected) => this._locationProvinceChange(selected)}
              />
            </div>
            <div className='offset-3 col-9'>
              <span style={{ fontSize: '13px', color: '#FF4444' }}>{this.state.error.selectedProvince}</span>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>City</label>
            </div>
            <div className='col-9'>
              <Select
                options={city}
                name='city-picker'
                required
                placeholder='Select City'
                value={this.state.selectedCity}
                onChange={(selected) => this._locationCityChange(selected)}
              />
            </div>
            <div className='offset-3 col-9'>
              <span style={{ fontSize: '13px', color: '#FF4444' }}>{this.state.error.selectedCity}</span>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>District</label>
            </div>
            <div className='col-9'>
              <Select
                options={district}
                name='district-picker'
                required
                placeholder='Select District'
                value={this.state.selectedDistrict}
                onChange={(selected) => this._locationDistrictChange(selected)}
              />
            </div>
            <div className='offset-3 col-9'>
              <span style={{ fontSize: '13px', color: '#FF4444' }}>{this.state.error.selectedDistrict}</span>
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Sub District</label>
            </div>
            <div className='col-9'>
              <input
                type='text'
                required
                placeholder='Sub District'
                className='form-control'
                value={this.state.address_sub_district}
                onChange={(event) => this._inputChange(event, 'address_sub_district')}
              />
            </div>
          </div>
          <div className='form-group row'>
            <div className='col-3'>
              <label className='control-label'>Postal Code</label>
            </div>
            <div className='col-9'>
              <input
                type='number'
                required
                placeholder='Postal Code'
                className='form-control'
                value={this.state.postal_code}
                onChange={(event) => this._inputChange(event, 'postal_code')}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12 text-right'>
              <button type='button' className='btn btn-secondary mr-2' onClick={() => this.props.closeModal()}>Cancel</button>
              <button type='submit' className='btn btn-primary'>Save</button>
            </div>
          </div>
        </form>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  location: state.location
})

const dispatchToProps = (dispatch) => ({
  updateSupplier: (data) => dispatch(SupplierActions.updateSupplierRequest(data)),
  getProvince: () => dispatch(LocationActions.getProvinceRequest()),
  getCities: (id) => dispatch(LocationActions.getCityRequest(id)),
  getDistricts: (id) => dispatch(LocationActions.getDistrictRequest(id))
})

export default connect(stateToProps, dispatchToProps)(UpdateSupplier)



// WEBPACK FOOTER //
// ./src/Containers/Ecommerce/UpdateSupplier.js